import { render } from "./CardPointeTokenizer.vue?vue&type=template&id=18f63b9b&scoped=true"
import script from "./CardPointeTokenizer.vue?vue&type=script&lang=js"
export * from "./CardPointeTokenizer.vue?vue&type=script&lang=js"

import "./CardPointeTokenizer.vue?vue&type=style&index=0&id=18f63b9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f63b9b"]])

export default __exports__